import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaPhone, FaEnvelope, FaEdit, FaWhatsapp, FaSave, FaTimes, FaWindowClose } from 'react-icons/fa';
import mainService from '../services/mainService';
import './MyAccount.css';

const MyAccount = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateError, setUpdateError] = useState(null);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [formData, setFormData] = useState({
    Name: '',
    MobileNo: '',
    EmailId: '',
    WhatsaapNo: ''
  });

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        setLoading(true);
        setError(null);

        const userDataStr = localStorage.getItem('userData');
        if (!userDataStr) {
          setError('Please login to view your account.');
          return;
        }

        const user = JSON.parse(userDataStr);
        const customerId = user.CustomerId || user.Id;
        if (!customerId) {
          setError('Customer information not found.');
          return;
        }

        const data = await mainService.GetCustomerById(customerId);
        setCustomerData(data);
        
        // Initialize form data with current customer data
        setFormData({
          Name: data?.Name || '',
          MobileNo: data?.MobileNo || '',
          EmailId: data?.EmailId || '',
          WhatsaapNo: data?.WhatsaapNo || ''
        });
      } catch (err) {
        console.error('Failed to load customer data:', err);
        setError('Failed to load your account information. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerData();
  }, []);

  const handleEditClick = () => {
    setShowModal(true);
    setUpdateError(null);
    setUpdateSuccess(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setUpdateError(null);
    setUpdateSuccess(false);
    // Reset form data to original values
    setFormData({
      Name: customerData?.Name || '',
      MobileNo: customerData?.MobileNo || '',
      EmailId: customerData?.EmailId || '',
      WhatsaapNo: customerData?.WhatsaapNo || ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      setUpdateLoading(true);
      setUpdateError(null);
      setUpdateSuccess(false);

      const userDataStr = localStorage.getItem('userData');
      if (!userDataStr) {
        setUpdateError('Please login to update your profile.');
        return;
      }

      const user = JSON.parse(userDataStr);
      const customerId = user.CustomerId || user.Id;
      if (!customerId) {
        setUpdateError('Customer information not found.');
        return;
      }

      // Add customer ID to the form data
      const updateData = {
        ...formData,
        CustomerId: customerId
      };

      const response = await mainService.UpdateProfile(updateData);
      
      if (response) {
        setUpdateSuccess(true);
        // Refresh customer data
        const updatedData = await mainService.GetCustomerById(customerId);
        setCustomerData(updatedData);
        // Close modal after 2 seconds
        setTimeout(() => {
          setShowModal(false);
          setUpdateSuccess(false);
        }, 2000);
      }
    } catch (err) {
      console.error('Failed to update profile:', err);
      setUpdateError('Failed to update your profile. Please try again later.');
    } finally {
      setUpdateLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="myaccount-page">
        <div className="container">
          <div className="loading-container">
            <div className="loading-spinner" />
            <p>Loading your account information...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="myaccount-page">
        <div className="container">
          <div className="error-container">
            <p className="error-message">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="myaccount-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">My Account</h1>
        </div>

        <div className="account-content">
          <div className="account-card">
            <div className="account-header">
              <div className="profile-avatar">
                <FaUser />
              </div>
              <div className="welcome-section">
                <h2 className="welcome-text">
                  Welcome, <span className="customer-name">{customerData?.Name || 'Customer'}</span>
                </h2>
                <p className="account-subtitle">Manage your account information</p>
              </div>
            </div>

            <div className="account-details">
              <div className="detail-item">
                <div className="detail-icon">
                  <FaPhone />
                </div>
                <div className="detail-content">
                  <label className="detail-label">Registered Mobile No:</label>
                  <span className="detail-value">{customerData?.MobileNo || '—'}</span>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <FaEnvelope />
                </div>
                <div className="detail-content">
                  <label className="detail-label">Registered Email:</label>
                  <span className="detail-value">{customerData?.EmailId || '—'}</span>
                </div>
              </div>
            </div>

                                      <div className="account-actions">
               <button className="edit-btn" onClick={handleEditClick}>
                 <FaEdit />
                 Edit Profile
               </button>
             </div>
           </div>

                       {/* Update Profile Modal */}
            {showModal && (
              <div className="modal-overlay" onClick={handleCloseModal}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                    <h3 className="modal-title">Update Profile</h3>
                    <button className="modal-close-btn" onClick={handleCloseModal}>
                      <FaWindowClose />
                    </button>
                  </div>
                  
                  <div className="modal-body">
                    {updateError && (
                      <div className="error-message update-error">
                        {updateError}
                      </div>
                    )}
                    
                    {updateSuccess && (
                      <div className="success-message">
                        Profile updated successfully!
                      </div>
                    )}

                    <form className="update-form" onSubmit={handleUpdateProfile}>
                      <div className="form-row">
                        <div className="form-group">
                          <label className="form-label">Your name:</label>
                          <input
                            type="text"
                            name="Name"
                            value={formData.Name}
                            onChange={handleInputChange}
                            className="form-input"
                            placeholder="Enter your name"
                            required
                          />
                        </div>
                        
                        <div className="form-group">
                          <label className="form-label">Your mobile no:</label>
                          <input
                            type="tel"
                            name="MobileNo"
                            value={formData.MobileNo}
                            onChange={handleInputChange}
                            className="form-input"
                            placeholder="Enter your mobile number"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label className="form-label">Email:</label>
                          <input
                            type="email"
                            name="EmailId"
                            value={formData.EmailId}
                            onChange={handleInputChange}
                            className="form-input"
                            placeholder="Enter your email"
                            required
                          />
                        </div>
                        
                        <div className="form-group">
                          <label className="form-label">WhatsApp No:</label>
                          <input
                            type="tel"
                            name="WhatsaapNo"
                            value={formData.WhatsaapNo}
                            onChange={handleInputChange}
                            className="form-input"
                            placeholder="Enter your WhatsApp number"
                          />
                        </div>
                      </div>

                      <div className="modal-actions">
                        <button 
                          type="submit" 
                          className="save-btn" 
                          disabled={updateLoading}
                        >
                          <FaSave />
                          {updateLoading ? 'Saving...' : 'Save Changes'}
                        </button>
                        <button 
                          type="button" 
                          className="cancel-btn" 
                          onClick={handleCloseModal}
                          disabled={updateLoading}
                        >
                          <FaTimes />
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
         </div>
       </div>
     </div>
   );
 };

export default MyAccount;
